import analyticsAction from "../analytics/analytics-action"

type ResourceProperties = {
  Resource?: string
  "Resource type"?: string
  "Is resource gated"?: boolean
}

export default function analyticsResource(objectEl: HTMLElement) {
  const type = objectEl.getAttribute("type")
  const resourceProperties: ResourceProperties = {}

  if (type == "application/pdf") {
    objectEl.addEventListener("load", () => {
      const dataUrl = objectEl.getAttribute("data")

      if (!dataUrl) {
        return
      }

      setProperties()
      analyticsAction("Resource downloaded", { ...resourceProperties })
    })
    return
  } else if (objectEl.tagName === "WISTIA-PLAYER") {
    objectEl.addEventListener("api-ready", () => {
      setProperties()
      analyticsAction("Resource downloaded", { ...resourceProperties })
    })
  } else {
    return
  }

  function setProperties() {
    resourceProperties.Resource = objectEl.dataset.title
    resourceProperties["Resource type"] = objectEl.dataset.resourceType
    resourceProperties["Is resource gated"] = objectEl.dataset.gated === "true"
  }
}
